var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelePhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.748,
    height: 15.499,
    viewBox: "0 0 10.748 15.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10165",
    "data-name": "\\uD328\\uC2A4 10165",
    d: "M586.041,19.837a11.247,11.247,0,0,0-1.487-2.091.839.839,0,0,0-1.047-.238l-.888.435a.28.28,0,0,1-.284-.013,2.171,2.171,0,0,1-.55-.494,33.14,33.14,0,0,1-1.87-3.957,1.319,1.319,0,0,1,.716-1.428c.068-.032.135-.065.2-.1a.78.78,0,0,0,.455-.786c-.14-1.027-.415-3.416-1.792-3.25a4.833,4.833,0,0,0-1.845.664c-.2.1-1.539.836-.806,3.857a21.654,21.654,0,0,0,1.225,4.1,15.96,15.96,0,0,0,1.23,2.28,10.884,10.884,0,0,0,2.321,2.57C584.03,23.392,586.113,20.427,586.041,19.837Z",
    transform: "translate(-575.95 -7.257)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelePhoneIcon);
export default __webpack_public_path__ + "static/media/TelePhoneIcon.d7fe177cd8294c78b14f81c598549b29.svg";
export { ForwardRef as ReactComponent };